import { render, staticRenderFns } from "./Kota.vue?vue&type=template&id=88190ad0&"
import script from "./Kota.vue?vue&type=script&lang=js&"
export * from "./Kota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports